var _effectorFileName = "/builds/gmini/front-ui-kit/src/Groupings/Groupings.styled.ts";
import styled from 'styled-components';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
export const SelectWrapper = styled.div`
  padding-left: ${({
  paddingLeft
}) => paddingLeft && `${paddingLeft}px`};
  display: flex;
`;
export const PropertyList = styled.div`
  &:not(:last-child) {
    padding-top: 5px;
  }
  &:first-child {
    padding: 14px 0 0 9px;
  }
`;
export const GropingContainer = styled.div`
  left: 0px;
  top: 0px;
  border-radius: 4px;
  background: #f4f4f8;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const GroupingFooterLayout = styled.div`
  display: flex;
  padding-top: 4px;
  padding-bottom: ${({
  lastRow
}) => lastRow ? '10px' : '6px'};
  padding-left: ${({
  paddingLeft
}) => paddingLeft && `${paddingLeft}px`};
`;
export const ReferenceLine = styled.div`
  width: 8px;
  opacity: 0.2;
  border-left: 1px solid #353b60;
  border-bottom: 1px solid #353b60;
  border-radius: 0 0 0 5px;
  height: ${({
  height
}) => `${height}px`};
`;
export const CloseIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({
  rowNumber
}) => rowNumber && rowNumber > 0 && '10px'};
  margin-left: 13px;
  margin-right: 8px;
`;
export const GroupingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
`;
export const HeaderText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  text-align: left;
  color: rgba(0, 3, 53, 1);
  white-space: nowrap;
  margin-right: 20px;
`;
export const HeaderTextWrap = styled.div`
  display: flex;
  align-items: center;
`;
export const DeleteIconButton = styled(IconButton)`
  & svg {
    width: 20px;
    height: 20px;
    &:hover {
      path {
        fill: rgba(53, 59, 96, 1);
      }
    }
  }
`;
export const ModalDeleteText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 21px;
`;
export const ModalDeleteButtonText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
export const ModalDeleteButton = styled(Button)`
  background: rgba(217, 87, 94, 1);
  white-space: nowrap;
  margin-right: 12px;
  color: #fff;
  &:hover {
    background: rgba(191, 55, 55, 1);
  }
`;
export const PopoverContent = styled.div`
  padding: 24px;
`;
export const ButtonsWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
`;
export const GroupingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 19px;
  max-width: 748px;
  padding-right: 24px;
`;